import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import BackToTop from '../components/backToTop/BackToTop';
import { convertProductIdToName } from '../functions/ProductIds';
/*import TagManager from 'react-gtm-module';*/
type Document = {
    id: number;
    documentType: string;
    documentName: string;
    downloadLink: string;
}
export default function YourDocuments(props: any) {
    const navigate = useNavigate();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [documents, setDocuments] = useState<Document[]>([]);
    const location = useLocation();

    useEffect(() => {
        if (!localStorage.getItem('userData')) navigate('/Login')
        props.setSidebarVisibility(false);

        if (location.state != null) {
            try {
                const userData = JSON.parse(localStorage.getItem('userData') || '');
                const token = userData.token;
                fetch(`${apiBaseUrl}admin/GetDocuments?policyNumber=${location.state.policyNumber}&insurer=${location.state.insurer}&type=${location.state.productType}`, {
                    headers: {
                        'Authorization': `Bearer ${userData.token}`
                    }
                })
                    .then((response) => (response.json()))
                    .then((data) => {
                        const parsedObject = JSON.parse(data.object)
                        setDocuments(parsedObject.value);
                    })
            } catch {

            }
        }
    }, [])

    const groupedDocuments = documents.reduce<Record<string, Document[]>>((acc, doc) => {
        const type = doc.documentType;
        if (!acc[type]) {
            acc[type] = [];
        }
        acc[type].push(doc);
        return acc;
    }, {});

    const documentTypeLabels: Record<string, string> = {
        MTA: "Midterm Adjustment",
        REN: "Renewal",
        NB: "Information Regarding Your Insurance Policy",
        CANX: "Cancellation",
        MISC: "Miscellaneous"
    };

    return (
        <>

            <div className="form-container">
                <div className="admin-section-header your-account-header">
                    <div className="account-h1">
                        <h1>{convertProductIdToName(location.state.productType)} - {location.state.insurer}</h1>
                    </div>
                </div>
                {documents.length === 0 && (<p>No documents available to view or download</p>)}
                {Object.keys(groupedDocuments).map((type) => (
                    <div key={type} className="document-section">
                        <h2>{documentTypeLabels[type] || type}</h2>
                        {groupedDocuments[type].map((doc) => (
                            <div key={doc.id} className="document-item">
                                <p>{doc.documentName}</p>
                                <div className="document-buttons">
                                    <button className="btn back" onClick={() => {
                                        window.open(doc.downloadLink, "_blank")
                                    }}>View Online</button>
                                    <button className="btn primary" onClick={() => {
                                        window.open(doc.downloadLink + "/False/" + doc.documentName, "_blank", "noopener,noreferrer")
                                    }}>Download
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
                <br />
                <div className="btn-container">

                    <button className="btn back" onClick={() => navigate('/YourAccount')}>Back: Your Account</button>
                </div>
            </div>
            <BackToTop />
        </>
    )
}